// import { API_BASE_URL, BEARER_TOKEN, BEARER_TOKEN_V2 } from './apiConfig';
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || '';
const BEARER_TOKEN_V2 = process.env.REACT_APP_BEARER_TOKEN_V2 || '';

interface securityQuestionResponse {
	timestamp: string;
	status: string;
	code: number;
	message: string;
	payload: security[];
}

interface security {
	id: string;
	chatbot_settings_id: string;
	question: string;
	encrypted_answer: string;
	created_at: string;
	deleted_at: string;
	deleted_by: string;
	last_updated_at: string;
  }

export const getSecurityQuestion = async (
	id: string,
): Promise<security[]> => {
	const apiUrl = `${API_BASE_URL}/v2/application/${id}/get/security-question`;
	try {
		const requestOptions: RequestInit = {
			method: 'GET',
			headers: {
				'Content-Type': 'application/json',
				'Bearer': BEARER_TOKEN_V2,
			},
		};

		const response = await fetch(apiUrl, requestOptions);
		const data: securityQuestionResponse = await response.json();

		if (!response.ok) {
			throw new Error(`HTTP error! Status: ${response.status}`);
		}
		return data.payload;
	} catch (error) {
		console.error('Error fetching security question:', error);
		throw error;
	}
};

export default getSecurityQuestion;
